// Função para normalizar CPF (remove caracteres não numéricos)
export const normalizeCpf = cpf => {
  if (!cpf) return "";
  return cpf.replace(/[^\d]/g, "");
};

// Função para validar CPF
export const validateCpf = fullCpf => {
  if (!fullCpf) return false;

  // Remove caracteres não numéricos
  const cpf = normalizeCpf(fullCpf);

  // Verifica se tem 11 dígitos
  if (cpf.length !== 11) {
    return false;
  }

  // Verifica se todos os dígitos são iguais (ex: 111.111.111-11)
  if (/^(\d)\1+$/.test(cpf)) {
    return false;
  }

  // Valida o primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i), 10) * (10 - i);
  }
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) {
    resto = 0;
  }
  if (resto !== parseInt(cpf.charAt(9), 10)) {
    return false;
  }

  // Valida o segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i), 10) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) {
    resto = 0;
  }
  if (resto !== parseInt(cpf.charAt(10), 10)) {
    return false;
  }

  return true;
};
